export enum FieldStatus {
  draft = 'draft',
  pending = 'pending',
  approved = 'approved',
  rejected = 'rejected',
}

export const FieldStatuses = [
  { value: FieldStatus.draft, label: 'Черновик' },
  { value: FieldStatus.pending, label: 'На рассмотрении' },
  { value: FieldStatus.approved, label: 'Утверждено' },
  { value: FieldStatus.rejected, label: 'Отклонено' },
];
export const FieldStatusActions = [
  { value: FieldStatus.draft, label: 'Сделать черновиком' },
  { value: FieldStatus.pending, label: 'Отправить на рассмотрение' },
  { value: FieldStatus.approved, label: 'Утвердить' },
  { value: FieldStatus.rejected, label: 'Отклонить' },
];

export enum FieldRenderMode {
  input = 'input',
  view = 'view',
}
export const FieldRenderModes = [
  { value: FieldRenderMode.input, label: 'Режим ввода' },
  { value: FieldRenderMode.view, label: 'Режим просмотра' },
];
